import Vue from 'vue'
import Router from 'vue-router'

// ─── Views: Web Pública ───────────────────────────────────────────────────────
import HomeView          from '../views/web/HomeView'
import PreciosView       from '../views/web/PreciosView'
import ContactoView      from '../views/web/ContactoView'

// ─── Views: Panel (socios) ────────────────────────────────────────────────────
import DashboardView     from '../views/socios/DashboardView'
import MiembrosView      from '../views/socios/MiembrosView'
import MembresiasView    from '../views/socios/MembresiasView'
import VentasView        from '../views/socios/VentasView'
import InventarioView    from '../views/socios/InventarioView'
import CajasView         from '../views/socios/CajasView'
import PagosView         from '../views/socios/PagosView'
import VisitasView       from '../views/socios/VisitasView'
import ClientesView      from '../views/socios/ClientesView'
import UsuariosView      from '../views/socios/UsuariosView'
import ConfiguracionView from '../views/socios/ConfiguracionView'
import CXCView           from '../views/socios/CXCView'
import AbonosView        from '../views/socios/AbonosView'

// ─── Views: Admin ─────────────────────────────────────────────────────────────
import GimnasiosView     from '../views/admin/GimnasiosView'
import UsuariosAdminView from '../views/admin/UsuariosAdminView'
import MonitoreoView     from '../views/admin/MonitoreoView'

// ─── Views: App (clientes) ────────────────────────────────────────────────────
import PerfilView        from '../views/clientes/PerfilView'
import MiMembresiaView   from '../views/clientes/MiMembresiaView'
import MisPagosView      from '../views/clientes/MisPagosView'
import MisVisitasView    from '../views/clientes/MisVisitasView'

// ─── Sub-componentes (forms / CRUD) ───────────────────────────────────────────
import CRUD_MembresiaForm  from '../components/Membresias/CRUD_MembresiaForm.vue'
import CRUD_membresias     from '../components/Membresias/Crud_membresias.vue'
import CRUD_MembresiaCARD  from '../components/Membresias/Crud_membresias_card.vue'
import CrearMembresia      from '../components/Membresias/Crear_membresias'
import CrearPlanes         from '../components/Membresias/Crear_planes.vue'
import CRUD_MiembroForm    from '../components/Miembros/crud_miembrosForm.vue'
import EditarMiembro       from '../components/Miembros/EditarMiembro'
import NuevoMiembro        from '../components/Miembros/NuevoMiembro'
import NuevoCliente        from '../components/Clientes/NuevoCliente.vue'
import EditarCliente       from '../components/Clientes/EditarCliente.vue'
import Cobros              from '../components/Pagos/Form_regPagos.vue'
import NuevoUsuario        from '../components/Usuarios/NuevoUsuario'
import EditarUsuario       from '../components/Usuarios/EditarUsuario'
import CambiarPassword     from '../components/Usuarios/CambiarPassword'
import MiPerfil            from '../components/Usuarios/MiPerfil'
import Chat                from '../components/Chat/Chat_ws'
import EnviaMsg            from '../components/Chat/Envia_msg.vue'
import EstadosMiembros     from '../components/Estados/EstadosMiembros.vue'
import EstadoCajas         from '../components/Estados/EstadoCajas_listar.vue'
import CajaCuadre          from '../components/cajas/caja_cuadre.vue'
import CRUD_Areas          from '../components/Configuracion/CRUD_Areas.vue'
import Sincronizar         from '../components/Configuracion/Sincronizar.vue'
import Dispositivos        from '../components/Configuracion/Dispositivos.vue'
import RegistrarVisita     from '../components/Visitas/RegistroVisitaMiembro.vue'
import ItemForm            from '../components/Inventario/Item_form.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    // ─── Web Pública (sin auth, sin layout) ───────────────────────────────────
    { path: '/',          name: 'WebHome',     component: HomeView },
    { path: '/precios',   name: 'WebPrecios',  component: PreciosView },
    { path: '/contacto',  name: 'WebContacto', component: ContactoView },

    // ─── Panel — socios / gimnasio ────────────────────────────────────────────
    { path: '/panel',           name: 'Dashboard',     component: DashboardView },
    { path: '/panel/miembros',  name: 'Miembros',      component: MiembrosView },
    { path: '/panel/membresias',name: 'Membresias',    component: MembresiasView },
    { path: '/panel/ventas',    name: 'Ventas',        component: VentasView },
    { path: '/panel/inventario',          name: 'Inventario',    component: InventarioView },
    { path: '/panel/inventario/nuevo',    name: 'NuevoItem',     component: ItemForm },
    { path: '/panel/inventario/editar/:codigo', name: 'EditarItem', component: ItemForm, props: true },
    { path: '/panel/cajas',     name: 'Cajas',         component: CajasView },
    { path: '/panel/pagos',     name: 'Pagos',         component: PagosView },
    { path: '/panel/visitas',   name: 'Visitas',       component: VisitasView },
    { path: '/panel/clientes',  name: 'Clientes',      component: ClientesView },
    { path: '/panel/usuarios',  name: 'Usuarios',      component: UsuariosView },
    { path: '/panel/configurar',name: 'Configuracion', component: ConfiguracionView },
    { path: '/panel/cxc',       name: 'CXC',           component: CXCView },
    { path: '/panel/abonos',    name: 'Abonos',        component: AbonosView },

    // Sub-rutas Miembros
    { path: '/panel/crud_miembros_card',    name: 'CrudMiembrosCard',  component: MiembrosView },
    { path: '/panel/crud_miembrosForm',     name: 'CrudCrearMiembro',  component: CRUD_MiembroForm },
    { path: '/panel/crud_miembrosForm/:id', name: 'CrudEditarMiembro', component: CRUD_MiembroForm },
    { path: '/panel/nuevo-miembro',         name: 'NuevoMiembro',      component: NuevoMiembro },
    { path: '/panel/editar-miembro/:id',    name: 'EditarMiembro',     component: EditarMiembro },

    // Sub-rutas Membresias
    { path: '/panel/crud_membresias',        name: 'CrudMembresias',      component: CRUD_membresias },
    { path: '/panel/crud_membresia_card',    name: 'CrudMembresiaCard',   component: CRUD_MembresiaCARD },
    { path: '/panel/crear_membresia',        name: 'CrearMembresia',      component: CrearMembresia },
    { path: '/panel/crear_planes',           name: 'CrearPlanes',         component: CrearPlanes },
    { path: '/panel/CRUD_MembresiaForm',     name: 'CrudCrearMembresia',  component: CRUD_MembresiaForm },
    { path: '/panel/CRUD_MembresiaForm/:id', name: 'CrudEditarMembresia', component: CRUD_MembresiaForm, props: true },

    // Sub-rutas Clientes
    { path: '/panel/Crear_cliente',                 name: 'CrearCliente',  component: NuevoCliente },
    { path: '/panel/editar-cliente/:client_rucCed', name: 'EditarCliente', component: EditarCliente, props: true },

    // Sub-rutas Pagos
    { path: '/panel/registrar-cobro', name: 'Cobros', component: Cobros },

    // Sub-rutas Usuarios
    { path: '/panel/nuevo-usuario',      name: 'NuevoUsuario',    component: NuevoUsuario },
    { path: '/panel/editar-usuario/:id', name: 'EditarUsuario',   component: EditarUsuario },
    { path: '/panel/cambiar-password',   name: 'CambiarPassword', component: CambiarPassword },
    { path: '/panel/perfil',             name: 'MiPerfil',        component: MiPerfil },

    // Sub-rutas Cajas
    { path: '/panel/caja_apertura', name: 'AperturarCaja', component: CajasView },
    { path: '/panel/caja_cuadre',   name: 'CajaCuadre',    component: CajaCuadre },
    { path: '/panel/estado_cajas',  name: 'EstadoCajas',   component: EstadoCajas },

    // Sub-rutas Visitas
    { path: '/panel/registrar-visita', name: 'RegistrarVisita', component: RegistrarVisita },

    // Sub-rutas Configuracion
    { path: '/panel/admin-areas',   name: 'AdminAreas',   component: CRUD_Areas },
    { path: '/panel/dispositivos',  name: 'Dispositivos', component: Dispositivos },
    { path: '/panel/sincronizar',   name: 'Sincronizar',  component: Sincronizar },

    // Otros
    { path: '/panel/estado_miembros', name: 'EstadoMiembros',   component: EstadosMiembros },
    { path: '/panel/chat',            name: 'Chat',              component: Chat },
    { path: '/panel/enviar_msg',      name: 'NotificarMiembros', component: EnviaMsg },

    // ─── Admin ────────────────────────────────────────────────────────────────
    { path: '/admin/gimnasios', name: 'AdminGimnasios', component: GimnasiosView },
    { path: '/admin/usuarios',  name: 'AdminUsuarios',  component: UsuariosAdminView },
    { path: '/admin/monitoreo', name: 'AdminMonitoreo', component: MonitoreoView },

    // ─── App — clientes ───────────────────────────────────────────────────────
    { path: '/app/perfil',    name: 'AppPerfil',    component: PerfilView },
    { path: '/app/membresia', name: 'AppMembresia', component: MiMembresiaView },
    { path: '/app/pagos',     name: 'AppPagos',     component: MisPagosView },
    { path: '/app/visitas',   name: 'AppVisitas',   component: MisVisitasView },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js